export default __webpack_public_path__ + "static/media/Foot_right.eb558aee.svg";